import { createFeatureSelector, createSelector } from '@ngrx/store'
import { AppStoreState } from './app.reducer'

export namespace AppSelectors {
  export const appSelector = createFeatureSelector<AppStoreState>('app')
  export const paymentAvailableSelector = createSelector(appSelector, state => (state ? state.paymentAvailable : false))
  export const noticeVisibleSelector = createSelector(appSelector, state => (state ? state.noticeVisible : false))
  export const cardMenuVisibleSelector = createSelector(appSelector, state => (state ? state.cardMenuVisible : false))
}
